import { Stack, StackProps, styled } from '@mui/material';

type ContainerProps = {
  hasGap: boolean;
} & StackProps;
export const Container = styled(Stack, { shouldForwardProp: (prop) => prop !== 'hasGap' })<ContainerProps>(
  ({ hasGap }) => ({
    gap: hasGap ? 20 : 0,
  }),
);
